import { useSelector, useDispatch } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./ProductZoomModal.module.css";

export default function ProductZoomModal() {
    const dispatch = useDispatch();
    const product = useSelector(state => state.visualizer.activeProduct);
    const productImage = `https://renderfarm1.chameleonpower.com/cham/getImage.ashx?spec=${product.specifier}&type=prod&extra=(focus=500)&Size=750`;
    const appliedFilters = useSelector(state => state.visualizer.appliedFilters);
    const handleClose = () => {
        dispatch(uiActions.setproductZoomModalActive(false));
    };

    console.log('use this->>',product.description)
    console.log(product)

    const handleDownload = async () => {
        try {
            const response = await fetch(productImage, { mode: "cors" });
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `${product.name.replace(/\s+/g, "_")}.jpg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error downloading the image:", error);
        }
    };

    const handleOrderSample = async () => {
        switch (product.description) {
            case 'Contour Wood':
                 window.open('https://commercial.tarkett.com/products/resilient/lvt/contour-wood', '_blank');
                break;
            case 'Contour Stone':
                window.open('https://commercial.tarkett.com/products/resilient/lvt/contour-stone', '_blank');
            break;
            case 'Contour Abstract':
                window.open('https://commercial.tarkett.com/products/resilient/lvt/contour-abstract', '_blank');
            break;
            case 'Victory Color Studio':
                if(product.name != "Mineral Chip"){
                    window.open('https://commercial.tarkett.com/products/resilient/lvt/hues-tones', '_blank');
                }else{
                    window.open('https://commercial.tarkett.com/products/resilient/lvt/mineral-chip', '_blank');
                }
            break;
            break;
            default:
                console.warn('Unknown category');
                break;
        }
    };


    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={styles.modalContent}>
                <div className={styles.info}>
                        <p className={styles.title}>{product.name} - {product.style}</p>
                        <p className={styles.subTitle}>{product.color} {product.sku}</p>
                        <div className={styles.flexRow}>
                        <button type="button" onClick={handleDownload}>Download</button>
                        <button className={styles.orderNow} type="button" onClick={handleOrderSample}>Order Sample</button>
                        </div>
                        {/* <a target="_blank" href="https://commercial.tarkett.com/products/resilient/lvt">Product Details</a> */}
                    </div>
                    <div className={styles.imageContainer}>
                        <img src={productImage} alt={`${product.name} image`} />
                    </div>
   
                    
                </div>
            </PopUpModal>
        </>
    );
}
